import { Button } from "@/components/ui/button";

interface FormSubmitButtonProps {
  isSubmitting: boolean;
  text?: string;
  loadingText?: string;
}

export const FormSubmitButton = ({ 
  isSubmitting, 
  text = "Submit",
  loadingText = "Submitting..."
}: FormSubmitButtonProps) => {
  return (
    <Button 
      type="submit" 
      className="w-full"
      disabled={isSubmitting}
      aria-busy={isSubmitting}
      aria-live="polite"
    >
      {isSubmitting ? loadingText : text}
    </Button>
  );
};